<template>
    <div dusk="ReadProgress" class="flex items-center justify-center px-4 text-sm text-theme-toolbar-icon">
        <div v-if="isPdf" class="px-2">
            <template v-if="currentPages">
                {{ currentPages[0] }}
                <template v-if="currentPages[1]"> - {{ currentPages[1] }}</template>
            </template>
            / {{ publicationNumberOfPages }}
        </div>
        <div v-if="isEpub && epubProgressReadout" class="px-2">
            <LoadingSpinner v-if="isLoading" class="pt-1" height="18px" width="18px" :not-centered="true" />
            <template v-else>{{ epubProgressReadout.current }} / {{ epubProgressReadout.total }}</template>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import LoadingSpinner from '../Utilities/LoadingSpinner.vue';

export default {
    name: 'ReadProgress',
    components: {
        LoadingSpinner,
    },
    computed: {
        // The EPUB pair arrives pre-resolved from the store so both numbers come from the same
        // scale; rendering them separately is what let a position sit over a printed total.
        ...mapGetters(['isPdf', 'isEpub', 'currentPages', 'publicationNumberOfPages', 'epubProgressReadout']),
        ...mapState(['isLoading']),
    },
};
</script>
